import React, { useState, useEffect, useCallback } from 'react';
import './Carousel.css';

// Import images
import img1 from '../assets/img/carousel/1.jpg';
import img2 from '../assets/img/carousel/2.png';
import img3 from '../assets/img/carousel/3.png';
import img4 from '../assets/img/carousel/4.jpg';
import img5 from '../assets/img/carousel/5.png';
import img6 from '../assets/img/carousel/6.png';

const carouselData = [
  {
    id: 1,
    title: "LLM-Based Molecular Generation",
    subtitle: "Revolutionizing drug discovery with advanced large language models and transformer architectures.",
    image: img1,
    link: "/platform-overview"
  },
  {
    id: 2,
    title: "Fragment-based molecular optimization",
    subtitle: "Intelligent structural analysis for precise molecular optimization and lead refinement.",
    image: img2,
    link: "/small-molecule-drugs"
  },
  {
    id: 3,
    title: "Quantum-Informed Structural Control",
    subtitle: "Harnessing quantum mechanics to ensure superior structural accuracy and binding affinity.",
    image: img3,
    link: "/intellectual-property"
  },
  {
    id: 4,
    title: "Multi-Objective ADMET Optimization",
    subtitle: "Streamlining drug development with comprehensive, AI-driven ADMET property predictions.",
    image: img4,
  },
  {
    id: 5,
    title: "Closed-Loop AI-Experimental Refinement",
    subtitle: "Accelerating progress through autonomous integration of AI predictions and experimental feedback.",
    image: img5,
  },
  {
    id: 6,
    title: "Agent-Driven Molecular Database",
    subtitle: "Unlocking deep insights with autonomous AI agents managing vast and complex chemical spaces.",
    image: img6,
  }
];

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + carouselData.length) % carouselData.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(nextSlide, 5000);
      return () => clearInterval(interval);
    }
  }, [isPaused, nextSlide]);

  return (
    <div
      className="carousel-container"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {carouselData.map((slide, index) => (
        <div
          key={slide.id}
          className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
        >
          <img src={slide.image} alt={slide.title} className="carousel-image" />
          <div className="carousel-overlay">
            <div className="carousel-content">
              <h2 className="carousel-title">{slide.title}</h2>
              <p className="carousel-subtitle">{slide.subtitle}</p>
              <a href={slide.link} className="carousel-btn">
                Discover More
                <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </div>
      ))}

      <button className="carousel-arrow carousel-arrow-prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="carousel-arrow carousel-arrow-next" onClick={nextSlide}>
        &#10095;
      </button>

      <div className="carousel-controls">
        {carouselData.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
